import React from 'react';

import { Box, Chip, Stack, Typography } from '@mui/material';

import { formatDateLong } from '~/services/TimeService';

import statusFormatter from '../formatters/statusFormatter';

interface Props {
  order: App.Order;
}

const formatStayDate = (date: string) => (date ? formatDateLong(new Date(date)) : 'No date');

/**
 * One line per accommodation_v2_items row, from the order alone: svc-accommodation's
 * booking details are per order, so enriching here would be one request per grid row.
 * Shadow rows are the shim's as-sold record beside a legacy item; native rows are bookings.
 */
export default function AccommodationV2ItemsCell({ order }: Props) {
  return (
    <Stack spacing={1}>
      {order.accommodation_v2_items?.map((item) => (
        <Box key={item.id}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Chip
              size="small"
              label={item.is_shadow ? 'Legacy shim' : 'Native'}
              color={item.is_shadow ? 'warning' : 'success'}
            />
            <Typography>{item.property_id}</Typography>
          </Stack>
          <Typography>
            {statusFormatter(`${item.booking_id || 'Adoption pending'} - ${item.status}`, item.status)}
          </Typography>
          <Typography color="text.secondary">
            {formatStayDate(item.check_in)} – {formatStayDate(item.check_out)} ({item.nights} nights)
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
